var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquadzenLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 41,
    viewBox: "0 0 51 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7764 38.9283C15.5447 42.6895 4.10318 37.6395 0.394537 27.5919L0 26.5135L1.1047 26.119C11.3364 22.3314 22.7516 27.4078 26.4603 37.4553L25.7764 38.9283Z",
    fill: "#FFA1CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5398 37.4553C28.2484 27.4078 39.6637 22.3314 49.8954 26.119L51.0001 26.5135L50.6055 27.5919C46.8969 37.6132 35.4553 42.6895 25.2237 38.9283L24.5398 37.4553Z",
    fill: "#FFD78F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5821 4.28746L45.7404 2.84082L43.7152 3.44578C26.3292 8.57476 17.2812 22.1205 22.0419 34.772C22.4628 35.8767 25.5928 39.033 25.5928 39.033C44.5305 33.4306 54.394 17.7543 46.5821 4.28746Z",
    fill: "#FFAF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49642 3.44578L5.47113 2.84082L4.62945 4.28746C-3.18238 17.7543 6.68104 33.4306 25.5925 39.033C25.5925 39.033 28.854 35.5874 29.3012 34.3512C33.72 21.8312 24.6982 8.52215 7.49642 3.44578Z",
    fill: "#FF006D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6183 39.0328C25.6183 39.0328 4.73413 31.8785 7.94303 9.88965C7.94303 9.88965 23.856 11.1259 25.6183 39.0328Z",
    fill: "#FF3998"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6189 39.0328C25.6189 39.0328 46.503 31.8785 43.2941 9.88965C43.2941 9.88965 27.3812 11.1259 25.6189 39.0328Z",
    fill: "#FFC248"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1709 1.1047L25.6191 0L24.0672 1.1047C9.57459 11.4416 9.57459 27.6176 24.0672 37.9281L25.6191 39.0328L27.1709 37.9281C41.6636 27.5913 41.6636 11.4416 27.1709 1.1047Z",
    fill: "#00CCC3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6187 32.9307C25.6187 32.9307 37.5863 25.1715 25.6187 16.6758C25.6187 16.6758 13.8352 23.83 25.6187 32.9307Z",
    fill: "#00E5CF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6185 19.8058C23.7773 19.8058 22.2781 18.3066 22.2781 16.4654C22.2781 14.6242 23.7773 13.125 25.6185 13.125C27.4597 13.125 28.9589 14.6242 28.9589 16.4654C28.9589 18.3066 27.4597 19.8058 25.6185 19.8058Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94337 12.8623C6.31262 12.8623 4.97119 11.5472 4.97119 9.89015C4.97119 8.25939 6.28631 6.91797 7.94337 6.91797C9.57412 6.91797 10.9155 8.23309 10.9155 9.89015C10.9155 11.5209 9.57412 12.8623 7.94337 12.8623Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2941 12.8623C41.6633 12.8623 40.3219 11.5472 40.3219 9.89015C40.3219 8.25939 41.637 6.91797 43.2941 6.91797C44.9248 6.91797 46.2662 8.23309 46.2662 9.89015C46.2399 11.5209 44.9248 12.8623 43.2941 12.8623Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquadzenLogo);
export default __webpack_public_path__ + "static/media/squadzen-logo.db4f5a477bb5e5442695c76727997f6f.svg";
export { ForwardRef as ReactComponent };